export default {
  table: (state) => {
    return state.table;
  },
  subTable: (state) => {
    return state.subTable;
  },
  tab: (state) => {
    return state.tab;
  },
  renderDetail: (state) => {
    return state.renderDetail;
  },
  detailData: (state) => {
    return state.detailData;
  },
  tabActive: (state) => {
    return state.tabActive;
  },
  id_user: (state) => {
    return state.id_user;
  },
};
